import { useEffect, useRef } from 'react';

/**
 * A declarative `setInterval` using Hooks
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 *
 * @param {Function} callback The function to execute at a specified interval.
 * @param {Number} delay The interval at which to execute `callback`.
 */

function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default useInterval;
